import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const deleteBlockedHashtag = async (id: string): Promise<void> => {
	await cmsClient.delete(`/homepage/admin/hashtags/blocked/${id}/`);
};

const useDeleteBlockedHashtag = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast
				type="Success"
				message="Blocked word removed successfully"
			/>,
			{ hideProgressBar: true }
		);
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["blocked-hashtags"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	return useMutation(deleteBlockedHashtag, {
		onError,
		onSuccess,
		onSettled
	});
};

export default useDeleteBlockedHashtag;
